import { Component } from '@angular/core';

@Component({
    selector: 'sf-error',
    imports: [],
    templateUrl: './error.component.html',
    styleUrl: './error.component.scss'
})
export class ErrorComponent {

}
